import React, { useState } from 'react';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
import { GuideModalHeader, GuideSuccess, GuideForm, GuideTypeToggle } from './guide/GuideParts';

const initialForm = { name: '', email: '', phone: '', smsConsent: false };

export const GuideModal = ({ open, onClose, guideType, setGuideType, openPrivacyPolicy }) => {
  const [form, setForm] = useState(initialForm);
  const { submitted, submitting, submit } = useLeadSubmit({
    endpoint: '/leads/guide-download',
    errorLabel: 'guide lead',
    onSuccess: () => {
      onClose();
      setForm(initialForm);
    },
  });

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    submit({ name: form.name, phone: form.phone, email: form.email, guide_type: guideType, sms_consent: form.smsConsent });
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="guide-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-sand-50 rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-fadeInUp">
        <GuideModalHeader guideType={guideType} onClose={onClose} />
        <div className="p-6">
          {submitted
            ? <GuideSuccess />
            : <GuideForm form={form} setForm={setForm} onSubmit={handleSubmit} submitting={submitting} onPrivacyClick={() => { onClose(); openPrivacyPolicy(); }} />}
        </div>
        {!submitted && <GuideTypeToggle guideType={guideType} setGuideType={setGuideType} />}
      </div>
    </div>
  );
};
